
import { useState } from 'react';

import { Link } from 'react-router';

import { Button, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from '@mui/material';

import { FaList } from "react-icons/fa";
import { FaChevronDown } from "react-icons/fa6";

import { ListItembuttonStyle, ListItemIconStyle, ListItemTextStyle, ListTypographyStyle, MenuItemStyle, TypographyAppBarStyle } from '../../styles/ListItemStyle';

import { catalogosList } from '../../data/catalogos';

export const ListItemCatalogos = () => {

    const [anchorEl, anchorElOpen] = useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);

    const handleOpen = ( e: React.MouseEvent<HTMLButtonElement, MouseEvent> ) => {
        anchorElOpen( e.currentTarget );
    };
    
    const handleClose = () => {
        anchorElOpen( null );
    };

    return (
        <>
        
            <ListItemText style={ ListItemTextStyle }>
        
                <Button color="inherit" style={ ListItembuttonStyle } onClick={ handleOpen }>

                    <FaList style={ ListItemIconStyle } />

                    <Typography sx={{ ...ListTypographyStyle, display: { xs: 'none', lg: 'flex' } }} >
                        Catálogos
                    </Typography>     
                    
                    <FaChevronDown style={ ListItemIconStyle } />  

                </Button>

            </ListItemText>

            <Menu 
                elevation={ 2 } 
                anchorEl={ anchorEl } 
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }} 
                keepMounted open={ open } 
                onClose={ handleClose }
                sx={{ width: 320 }}
            >

                {
                    catalogosList
                    .filter( ({ user }) => user === true )
                    .map( ({ id, descripcion, path }) => (

                        <Link key={ id } to={ path } style={{ textDecoration: "none" }}>
                            <MenuItem sx={{ ...MenuItemStyle, py: 2 }} onClick={ handleClose }> 
                                <ListItemIcon style={ ListItemIconStyle }> <FaList style={ ListItemIconStyle } /> </ListItemIcon>
                                <ListItemText style={TypographyAppBarStyle}>{ descripcion }</ListItemText>
                            </MenuItem>   
                        </Link>

                   ))
                }

            </Menu>
        
        </>        
    )
}